import { TenantTrackingId, TrackingDataMap } from './types/trackingDataModel';
import { TrackingUpdateAction } from './types/actions';
import { getTrackingHandler } from './handlers/trackingHandlerRegistry';
import { TrackingActionType } from './constants/constants';

export const createTrackingReducer = <T extends TenantTrackingId>(
  tenantId: T | null
) => {
  return (
    state: TrackingDataMap[T] | null,
    action: TrackingUpdateAction
  ): TrackingDataMap[T] | null => {
    if (!state || !tenantId) return state;

    const handler = getTrackingHandler(tenantId);
    if (!handler) return state;

    const updateMap: Record<
      TrackingActionType,
      | ((
          payload: any,
          data: TrackingDataMap[T]
        ) => Partial<TrackingDataMap[T]> | null | undefined)
      | undefined
    > = {
      reset: (_payload) => _payload,
      trackingMetadata: handler.updateTrackingMetadata,
      sar: handler.updateSARConsentInfo,
      device: handler.updateDeviceInfo,
      queryParams: handler.updateFromQueryParams,
      step: handler.updateOnStepChange,
      custom: handler.handleCustomAction,
      success: handler.updateOnSuccess,
      login: handler.updateOnLogin,
    };

    const updater = updateMap[action.type];
    if (!updater) return state;

    const updated = updater(action.payload ?? '', state);
    if (updated && Object.keys(updated).length > 0) {
      return { ...state, ...updated };
    }

    return state;
  };
};
